import { createFileRoute } from '@tanstack/react-router';
import EntryIndexPage from '@/features/resume-builder/entry/EntryIndexPage';

/** DEV-483 — `Home / Create` (sem currículo) ou `Home / Already created` (com currículo gerado). */
export const Route = createFileRoute('/perfil/curriculo/')({
  component: EntryIndexPage,
});
